(() => {
  const KEY = 'chikas:favorites';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ANIM_MS = reduceMotion ? 0 : 480;

  const read = () => {
    try {
      const list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((f) => f && f.handle) : [];
    } catch (e) {
      return [];
    }
  };
  let favs = read();

  const save = () => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(favs));
    } catch (e) {}
  };

  const has = (handle) => favs.some((f) => f.handle === handle);

  const escapeHtml = (s) =>
    String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const fromCard = (card) => ({
    handle: card.dataset.favHandle,
    url: card.dataset.favUrl,
    title: card.dataset.favTitle,
    meta: card.dataset.favMeta,
    price: card.dataset.favPrice,
    image: card.dataset.favImage,
  });

  const syncHearts = (root = document) => {
    root.querySelectorAll('[data-chikas-fav]').forEach((btn) => {
      const card = btn.closest('[data-fav-handle]');
      if (!card) return;
      const on = has(card.dataset.favHandle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Quitar de favoritos' : 'Añadir a favoritos');
    });
  };

  const drawer = document.querySelector('[data-chikas-favs-drawer]');
  const listEl = drawer && drawer.querySelector('[data-chikas-favs-list]');
  const emptyEl = drawer && drawer.querySelector('[data-chikas-favs-empty]');
  const pill = drawer && drawer.querySelector('[data-chikas-favs-pill]');
  const pillNum = drawer && drawer.querySelector('[data-chikas-favs-num]');
  const pillUnit = drawer && drawer.querySelector('[data-chikas-favs-unit]');

  const syncCount = (pulse) => {
    const n = favs.length;
    document.querySelectorAll('[data-chikas-favs-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
      if (pulse && n > 0) {
        el.classList.remove('is-pulse');
        void el.offsetWidth;
        el.classList.add('is-pulse');
      }
    });
    if (pill) {
      pill.hidden = n === 0;
      pillNum.textContent = n;
      pillUnit.textContent = n === 1 ? 'prenda' : 'prendas';
    }
  };

  const renderList = () => {
    if (!listEl) return;
    const empty = favs.length === 0;
    listEl.hidden = empty;
    if (emptyEl) emptyEl.hidden = !empty;
    listEl.innerHTML = favs
      .map(
        (f) => `<li class="chikas-favs__item">
          <a class="chikas-favs__img" href="${escapeHtml(f.url)}">${
            f.image ? `<img src="${escapeHtml(f.image)}" alt="" width="72" height="96" loading="lazy">` : ''
          }</a>
          <div class="chikas-favs__info">
            <a class="chikas-favs__title" href="${escapeHtml(f.url)}">${escapeHtml(f.title)}</a>
            ${f.meta ? `<span class="chikas-favs__meta">${escapeHtml(f.meta)}</span>` : ''}
            ${f.price ? `<span class="chikas-favs__price">${escapeHtml(f.price)}</span>` : ''}
            <a class="chikas-favs__link" href="${escapeHtml(f.url)}">VER PRENDA</a>
          </div>
          <button type="button" class="chikas-favs__remove" data-chikas-fav-remove="${escapeHtml(f.handle)}" aria-label="Quitar ${escapeHtml(f.title)} de favoritos">✕</button>
        </li>`
      )
      .join('');
  };

  const refresh = (pulse) => {
    syncHearts();
    syncCount(pulse);
    renderList();
  };

  const toggle = (card, btn) => {
    const handle = card.dataset.favHandle;
    if (!handle) return;
    const adding = !has(handle);
    favs = adding ? [fromCard(card), ...favs] : favs.filter((f) => f.handle !== handle);
    save();
    if (adding && btn && !reduceMotion) {
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
    }
    refresh(adding);
  };

  let closingTimer = 0;
  const open = () => {
    if (!drawer) return;
    renderList();
    window.clearTimeout(closingTimer);
    drawer.classList.remove('is-closing');
    if (!drawer.open) {
      if (typeof drawer.showModal === 'function') drawer.showModal();
      else drawer.setAttribute('open', '');
    }
    document.documentElement.classList.add('chikas-drawer-open');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
  };

  const close = () => {
    if (!drawer || !drawer.open) return;
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    document.documentElement.classList.remove('chikas-drawer-open');
    window.clearTimeout(closingTimer);
    closingTimer = window.setTimeout(() => {
      if (typeof drawer.close === 'function') drawer.close();
      else drawer.removeAttribute('open');
      drawer.classList.remove('is-closing');
    }, ANIM_MS);
  };

  document.addEventListener('click', (e) => {
    const heart = e.target.closest('[data-chikas-fav]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      const card = heart.closest('[data-fav-handle]');
      if (card) toggle(card, heart);
      return;
    }
    if (e.target.closest('[data-chikas-favs-open]')) {
      e.preventDefault();
      open();
      return;
    }
    const remove = e.target.closest('[data-chikas-fav-remove]');
    if (remove) {
      favs = favs.filter((f) => f.handle !== remove.dataset.chikasFavRemove);
      save();
      refresh(false);
      return;
    }
    if (e.target.closest('[data-chikas-favs-close]')) close();
  });

  if (drawer) {
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) close();
    });
    drawer.addEventListener('cancel', (e) => {
      e.preventDefault();
      close();
    });
  }

  window.addEventListener('storage', (e) => {
    if (e.key !== KEY) return;
    favs = read();
    refresh(false);
  });

  let queued = false;
  const main = document.getElementById('MainContent');
  if (main) {
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        syncHearts();
      });
    }).observe(main, { childList: true, subtree: true });
  }

  refresh(false);
})();
